export default "__VITE_PUBLIC_ASSET__5cb986b7__"